/**
 * Mock data for GraphicalView component
 * Contains chart data for vendor, department, and category views
 */

import type {
  ChartDataItem,
  SegmentGradient,
} from '../components/Dashboard/GraphicalView/type';

// Vendor view chart data
export const vendorChartData: ChartDataItem[] = [
  {
    label: 'SAP',
    segments: [
      { categoryId: 'licenses-used', value: 816000 },
      { categoryId: 'total-cost', value: 1200000 },
    ],
    overlayValue: 68,
  },
  {
    label: 'MS Office 365',
    segments: [
      { categoryId: 'licenses-used', value: 712500 },
      { categoryId: 'total-cost', value: 950000 },
    ],
    overlayValue: 75,
  },
  {
    label: 'AWS',
    segments: [
      { categoryId: 'licenses-used', value: 891000 },
      { categoryId: 'total-cost', value: 1100000 },
    ],
    overlayValue: 81,
  },
  {
    label: 'Salesforce',
    segments: [
      { categoryId: 'licenses-used', value: 620500 },
      { categoryId: 'total-cost', value: 850000 },
    ],
    overlayValue: 73,
  },
  {
    label: 'Workday',
    segments: [
      { categoryId: 'licenses-used', value: 966000 },
      { categoryId: 'total-cost', value: 1050000 },
    ],
    overlayValue: 92,
  },
  {
    label: 'UltiPro',
    segments: [
      { categoryId: 'licenses-used', value: 764400 },
      { categoryId: 'total-cost', value: 780000 },
    ],
    overlayValue: 98,
  },
  {
    label: 'ADP',
    segments: [
      { categoryId: 'licenses-used', value: 432400 },
      { categoryId: 'total-cost', value: 920000 },
    ],
    overlayValue: 47,
  },
  {
    label: 'Jira',
    segments: [
      { categoryId: 'licenses-used', value: 533000 },
      { categoryId: 'total-cost', value: 650000 },
    ],
    overlayValue: 82,
  },
  {
    label: 'ServiceNow',
    segments: [
      { categoryId: 'licenses-used', value: 1209000 },
      { categoryId: 'total-cost', value: 1300000 },
    ],
    overlayValue: 93,
  },
  {
    label: 'Zendesk',
    segments: [
      { categoryId: 'licenses-used', value: 475400 },
      { categoryId: 'total-cost', value: 580000 },
    ],
    overlayValue: 82,
  },
  {
    label: 'Oracle',
    segments: [
      { categoryId: 'licenses-used', value: 1435500 },
      { categoryId: 'total-cost', value: 1450000 },
    ],
    overlayValue: 99,
  },
  {
    label: 'Azure',
    segments: [
      { categoryId: 'licenses-used', value: 638000 },
      { categoryId: 'total-cost', value: 1100000 },
    ],
    overlayValue: 58,
  },
];

// Department view chart data
export const departmentChartData: ChartDataItem[] = [
  {
    label: 'HR',
    segments: [
      { categoryId: 'licenses-used', value: 500000 },
      { categoryId: 'total-cost', value: 750000 },
    ],
    overlayValue: 68,
  },
  {
    label: 'IT',
    segments: [
      { categoryId: 'licenses-used', value: 850000 },
      { categoryId: 'total-cost', value: 1100000 },
    ],
    overlayValue: 75,
  },
  {
    label: 'Finance',
    segments: [
      { categoryId: 'licenses-used', value: 720000 },
      { categoryId: 'total-cost', value: 900000 },
    ],
    overlayValue: 81,
  },
  {
    label: 'Marketing',
    segments: [
      { categoryId: 'licenses-used', value: 450000 },
      { categoryId: 'total-cost', value: 620000 },
    ],
    overlayValue: 73,
  },
  {
    label: 'Sales',
    segments: [
      { categoryId: 'licenses-used', value: 680000 },
      { categoryId: 'total-cost', value: 850000 },
    ],
    overlayValue: 92,
  },
  {
    label: 'Engineering',
    segments: [
      { categoryId: 'licenses-used', value: 920000 },
      { categoryId: 'total-cost', value: 1200000 },
    ],
    overlayValue: 98,
  },
];

// Category view - Region data
export const categoryRegionChartData: ChartDataItem[] = [
  {
    label: 'Productivity',
    segments: [
      { categoryId: 'licenses-used', value: 800000 },
      { categoryId: 'total-cost', value: 1200000 },
    ],
    overlayValue: 68,
  },
  {
    label: 'CRM',
    segments: [
      { categoryId: 'licenses-used', value: 650000 },
      { categoryId: 'total-cost', value: 950000 },
    ],
    overlayValue: 75,
  },
  {
    label: 'Security Tools',
    segments: [
      { categoryId: 'licenses-used', value: 720000 },
      { categoryId: 'total-cost', value: 900000 },
    ],
    overlayValue: 81,
  },
  {
    label: 'DevOps',
    segments: [
      { categoryId: 'licenses-used', value: 450000 },
      { categoryId: 'total-cost', value: 620000 },
    ],
    overlayValue: 73,
  },
  {
    label: 'Design',
    segments: [
      { categoryId: 'licenses-used', value: 680000 },
      { categoryId: 'total-cost', value: 850000 },
    ],
    overlayValue: 92,
  },
  {
    label: 'Analytics',
    segments: [
      { categoryId: 'licenses-used', value: 920000 },
      { categoryId: 'total-cost', value: 1200000 },
    ],
    overlayValue: 98,
  },
  {
    label: 'ERP',
    segments: [
      { categoryId: 'licenses-used', value: 764400 },
      { categoryId: 'total-cost', value: 780000 },
    ],
    overlayValue: 62,
  },
];

// Category view - Cost Center data
export const categoryCostCenterChartData: ChartDataItem[] = [
  {
    label: 'Operations',
    segments: [
      { categoryId: 'licenses-used', value: 900000 },
      { categoryId: 'total-cost', value: 1300000 },
    ],
    overlayValue: 72,
  },
  {
    label: 'Technology',
    segments: [
      { categoryId: 'licenses-used', value: 750000 },
      { categoryId: 'total-cost', value: 1050000 },
    ],
    overlayValue: 78,
  },
  {
    label: 'Business',
    segments: [
      { categoryId: 'licenses-used', value: 620000 },
      { categoryId: 'total-cost', value: 850000 },
    ],
    overlayValue: 85,
  },
  {
    label: 'Support',
    segments: [
      { categoryId: 'licenses-used', value: 480000 },
      { categoryId: 'total-cost', value: 680000 },
    ],
    overlayValue: 70,
  },
  {
    label: 'Development',
    segments: [
      { categoryId: 'licenses-used', value: 820000 },
      { categoryId: 'total-cost', value: 1100000 },
    ],
    overlayValue: 88,
  },
  {
    label: 'Infrastructure',
    segments: [
      { categoryId: 'licenses-used', value: 950000 },
      { categoryId: 'total-cost', value: 1250000 },
    ],
    overlayValue: 95,
  },
];

// Segment colors configuration
export const segmentColors = ['#0294f7', '#495473']; // total-cost, licenses-used (gradient applied separately)

// Gradient configuration for chart segments
export const segmentGradients: SegmentGradient[] = [
  {
    categoryId: 'licenses-used',
    startColor: '#0294f7',
    endColor: '#66acff',
    offset: 68.5,
  },
];

// Application logo mapping for vendor view
export const applicationLogoMap: Record<string, string> = {
  SAP: 'SAP',
  'MS Office 365': 'Microsoft',
  AWS: 'AWS',
  Salesforce: 'Salesforce',
  Workday: 'Workday',
  UltiPro: 'UltiPro',
  ADP: 'ADP',
  Jira: 'Jira',
  ServiceNow: 'ServiceNow',
  Zendesk: 'Zendesk',
  Oracle: 'Oracle',
  Azure: 'Azure',
};

/**
 * Software Obsolescence widget list items
 */
export const SOFTWARE_OBSOLESCENCE_ITEMS = [
  {
    logo: 'Office365',
    appName: 'MS Office 365',
    expiryDate: 'Expired 04/22/2025',
    cost: '$750,000',
    usage: '180/250 (72%)',
  },
  {
    logo: 'Oracle',
    appName: 'Oracle',
    expiryDate: 'Expired 05/18/2025',
    cost: '$580,000',
    usage: '160/250 (64%)',
  },
  {
    logo: 'ServiceNow',
    appName: 'ServiceNow',
    expiryDate: 'Expired 08/25/2025',
    cost: '$366,000',
    usage: '145/250 (58%)',
  },
  {
    logo: 'Azure',
    appName: 'Azure',
    expiryDate: 'Expired 08/25/2025',
    cost: '$240,500',
    usage: '110/250 (44%)',
  },
];

/**
 * Industry Benchmarks widget list items
 */
export const INDUSTRY_BENCHMARKS_ITEMS = [
  {
    label: 'Productivity Software',
    sublabel: 'You spent $4,250,000',
    percentage: '109% of avg',
    chipType: 'critical',
  },
  {
    label: 'CRM Systems',
    sublabel: 'You spend $2,575,000',
    percentage: '109% of avg',
    chipType: 'critical',
  },
  {
    label: 'Security Tools',
    sublabel: 'You spend $1,890,000',
    percentage: '89% of avg',
    chipType: 'success',
  },
  {
    label: 'Identity Governance',
    sublabel: 'You spend $1,470,000',
    percentage: '89% of avg',
    chipType: 'success',
  },
];

/**
 * Applications with most license waste widget data
 */
export const APPLICATIONS_WITH_MOST_WASTE_ITEMS = [
  { logo: 'SAP', name: 'SAP ECC', waste: '$42,300' },
  { logo: 'Salesforce', name: 'Salesforce', waste: '$31,100' },
  { logo: 'Office365', name: 'Office 365', waste: '$18,400' },
  { logo: 'Workday', name: 'Workday', waste: '$12,800' },
  { logo: 'AWS', name: 'AWS', waste: '$9,200' },
];

/**
 * Users with most license waste widget data
 */
export const USERS_WITH_MOST_WASTE_ITEMS = [
  { name: 'Sarah Johnson', waste: '$2,880' },
  { name: 'Michael Lee', waste: '$1,920' },
  { name: 'Emily Davis', waste: '$1,440' },
  { name: 'David Kim', waste: '$1,152' },
  { name: 'Olivia Martinez', waste: '$960' },
];

/**
 * Vendors with most dormant users widget data
 */
export const VENDORS_WITH_MOST_DORMANT_USERS_ITEMS = [
  { logo: 'SAP', name: 'SAP ECC', count: '47' },
  { logo: 'Office365', name: 'Office 365', count: '31' },
  { logo: 'Salesforce', name: 'Salesforce', count: '24' },
  { logo: 'Workday', name: 'Workday', count: '18' },
  { logo: 'AWS', name: 'AWS', count: '9' },
];

/**
 * Licenses with most unassigned seats widget data
 */
export const LICENSES_WITH_MOST_UNASSIGNED_SEATS_ITEMS = [
  { logo: 'Office365', name: 'Office 365 E3', seats: '312 seats' },
  { logo: 'Salesforce', name: 'Salesforce Enterprise', seats: '187 seats' },
  { logo: 'ServiceNow', name: 'ServiceNow ITSM', seats: '94 seats' },
  { logo: 'Workday', name: 'Workday HCM', seats: '63 seats' },
  { logo: 'AWS', name: 'AWS Business Support', seats: '41 seats' },
];

/**
 * Software Obsolescence widget metric
 */
export const SOFTWARE_OBSOLESCENCE_METRIC = {
  value: '$1,936,500',
  label: 'Total at Risk',
};
